module.exports = __webpack_public_path__ + "img/mangguoxuelong.81d4cf9e.jpg";